export default __webpack_public_path__ + "static/media/yogesh-arya.a2211926.jpg";